/**
 * abilityVfxSoraka — Soraka Q/W/E/R star silhouettes (SPY-312).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildStarcall(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.5);
  const gold = mat(THREE, spec.color || 0xfde047, 0.88);
  const soft = mat(THREE, 0xfef9c3, 0.8);
  const star = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), gold);
  star.position.y = 0.85 * s;
  group.add(star);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.8 * s, 20).rotateX(-Math.PI / 2),
    soft
  );
  ring.position.y = 0.05;
  group.add(ring);
  const spike = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.4 * s, 6), gold);
  spike.position.y = 1.25 * s;
  group.add(spike);
  group.userData = { shape: 'starcall' };
  return group;
}

export function buildAstralInfusion(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.2);
  const rose = mat(THREE, spec.color || 0xf472b6, 0.85);
  const glow = mat(THREE, 0xfbcfe8, 0.8);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.32 * s, 10, 10), rose);
  core.position.y = 0.55 * s;
  group.add(core);
  const halo = new THREE.Mesh(new THREE.TorusGeometry(0.42 * s, 0.05 * s, 8, 16), glow);
  halo.rotation.x = Math.PI / 2;
  halo.position.y = 0.55 * s;
  group.add(halo);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.1 * s, 8, 8), glow);
  spark.position.set(0.35 * s, 0.9 * s, 0);
  group.add(spark);
  group.userData = { shape: 'astral_infusion' };
  return group;
}

export function buildEquinox(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.75 * (spec.scale || 1.6);
  const dusk = mat(THREE, spec.color || 0xa78bfa, 0.85);
  const rim = mat(THREE, 0xddd6fe, 0.75);
  const disc = new THREE.Mesh(
    new THREE.CylinderGeometry(0.55 * s, 0.55 * s, 0.08 * s, 16),
    dusk
  );
  disc.position.y = 0.08;
  group.add(disc);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.5 * s, 0.85 * s, 20).rotateX(-Math.PI / 2),
    rim
  );
  ring.position.y = 0.12;
  group.add(ring);
  const pillar = new THREE.Mesh(new THREE.CylinderGeometry(0.08 * s, 0.08 * s, 0.9 * s, 8), dusk);
  pillar.position.y = 0.5 * s;
  group.add(pillar);
  group.userData = { shape: 'equinox' };
  return group;
}

export function buildWish(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.85 * (spec.scale || 1.8);
  const gold = mat(THREE, spec.color || 0xfacc15, 0.88);
  const soft = mat(THREE, 0xfef08a, 0.8);
  const dome = new THREE.Mesh(new THREE.SphereGeometry(0.55 * s, 12, 10), gold);
  dome.position.y = 0.6 * s;
  group.add(dome);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.4 * s, 0.95 * s, 24).rotateX(-Math.PI / 2),
    soft
  );
  ring.position.y = 0.05;
  group.add(ring);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.14 * s, 8, 8), soft);
  spark.position.set(0, 1.15 * s, 0);
  group.add(spark);
  group.userData = { shape: 'wish' };
  return group;
}
